/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import * as React from 'react';
import { Router, Route } from 'react-router-dom';

import { useHubeeFiltresReset } from '@/hooks';
import { AdresseZustandProvider } from '@mairistem/administres-utils';
import {
  EntiteZustandProvider,
  UtilisateurZustandProvider,
  ParametresZustandProvider,
  ProduitDomaineZustandProvider,
  TrimestreZustandProvider,
} from '../Zustand';

const HubeeFiltresResetHandler = () => {
  useHubeeFiltresReset();
  return null;
};

const Context = (p) => {
  const { children, path, history, scope, user } = p;

  return (
    <Router history={history}>
      <Route path={path}>
        <HubeeFiltresResetHandler />
        {scope === 'content' ? (
          <ProduitDomaineZustandProvider>
            <AdresseZustandProvider>
              <UtilisateurZustandProvider user={user}>
                <EntiteZustandProvider>
                  <TrimestreZustandProvider>
                    <ParametresZustandProvider>
                      {React.isValidElement(children)
                        ? children
                        : React.createElement(children)}
                    </ParametresZustandProvider>
                  </TrimestreZustandProvider>
                </EntiteZustandProvider>
              </UtilisateurZustandProvider>
            </AdresseZustandProvider>
          </ProduitDomaineZustandProvider>
        ) : React.isValidElement(children) ? (
          children
        ) : (
          React.createElement(children)
        )}
      </Route>
    </Router>
  );
};

export default Context;
